import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { utils } from 'passiv-libs'

const appendScriptToHead = ({ src, scriptId }) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.id = scriptId
    script.crossOrigin = ''
    script.src = src
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}

const MicroFrontend = ({ name, scriptName }) => {
  const history = useHistory()
  const location = useLocation()
  const renderMicroFrontend = () => {
    if (window[`render${name}`]) window[`render${name}`](`${name}-container`)
  }

  useEffect(() => {
    init()
    return () => {
      const currentLocationRoutePath = location.pathname.split("/")[1]
      const newLocationRoutePath = history.location.pathname.split("/")[1]
      // Only want to unmount micro app if new location's route path is not the same as the current one
      if (currentLocationRoutePath !== newLocationRoutePath && window[`unmount${name}`]) window[`unmount${name}`](`${name}-container`)
    }
  })

  const init = async () => {
    const scriptId = `micro-frontend-script-${name}`

    if (document.getElementById(scriptId)) {
      renderMicroFrontend()
      return
    }

    try {
      const buildNumber = process.env.BUILD_NUMBER || ''
      await appendScriptToHead({
        // DEV-31731: src: `${utils.settings.getAssetUrl()}js/${scriptName}?v=${buildNumber}`,
        src: `js/${scriptName}?v=${buildNumber}`,
        scriptId
      })
      renderMicroFrontend()
    } catch (error) {
      history.push('/')
      document.getElementById(scriptId).remove()
      utils.general.triggerErrorModal({ type: 'INTERNET' })
    }
  }

  return <div id={`${name}-container`} data-component="microapp-container" className="h-full" />
}

export default MicroFrontend
